var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.11422 2.08971C8.95212 0.636763 11.0487 0.636763 11.8867 2.08971L19.7054 15.6294C20.5433 17.0823 19.4938 18.8976 17.818 18.8976H2.18167C0.504614 18.8976 -0.543699 17.0823 0.295449 15.6294L8.11422 2.08971ZM10.0004 5.2085C10.2481 5.2085 10.4856 5.30688 10.6607 5.482C10.8358 5.65711 10.9342 5.89462 10.9342 6.14227V10.4999C10.9342 10.7475 10.8358 10.985 10.6607 11.1601C10.4856 11.3353 10.2481 11.4336 10.0004 11.4336C9.75278 11.4336 9.51528 11.3353 9.34016 11.1601C9.16504 10.985 9.06666 10.7475 9.06666 10.4999V6.14227C9.06666 5.89462 9.16504 5.65711 9.34016 5.482C9.51528 5.30688 9.75278 5.2085 10.0004 5.2085ZM10.0004 16.4137C10.3306 16.4137 10.6473 16.2826 10.8808 16.0491C11.1143 15.8156 11.2455 15.4989 11.2455 15.1687C11.2455 14.8385 11.1143 14.5218 10.8808 14.2884C10.6473 14.0549 10.3306 13.9237 10.0004 13.9237C9.67023 13.9237 9.35355 14.0549 9.12007 14.2884C8.88658 14.5218 8.75541 14.8385 8.75541 15.1687C8.75541 15.4989 8.88658 15.8156 9.12007 16.0491C9.35355 16.2826 9.67023 16.4137 10.0004 16.4137Z",
    fill: "#FFBB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.08b5818b2163a03fbd72236f9882c494.svg";
export { ForwardRef as ReactComponent };